import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CategoriesService } from 'src/app/services/categori.service';

function passwordMatch(control: AbstractControl): ValidationErrors | null {
  const newPw = control.get('new_password')?.value;
  const confirmPw = control.get('confirm_password')?.value;
  return newPw === confirmPw ? null : { mismatch: true };
}

@Component({
  standalone: false,
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  form: FormGroup | any;
  loading = false;

  constructor(private rest: CategoriesService) {}

  ngOnInit() {
    this.form = new FormGroup(
      {
        current_password: new FormControl('', [Validators.required, Validators.minLength(8)]),
        new_password: new FormControl('', [Validators.required, Validators.minLength(8)]),
        confirm_password: new FormControl('', [Validators.required]),
      },
      { validators: passwordMatch }
    );
  }

  submit() {
    if (!this.form.valid) {
      if (this.form.errors?.['mismatch']) {
        this.rest.errorToaster('toast.passwords_no_match');
      }
      return;
    }
    this.loading = true;
    const { current_password, new_password } = this.form.value;
    this.rest.changePassword({ current_password, new_password }).subscribe(
      (res: any) => {
        this.loading = false;
        this.form.reset();
        this.rest.successToast('toast.password_changed');
      },
      (err: any) => {
        this.loading = false;
        this.rest.errorToaster(err?.error?.message || 'toast.password_change_failed');
      }
    );
  }
}
